import { routes, apiClient, type ApiClientResponse } from 'common/services';

type DeleteCalendarSyncRequestParams = {
  provider: string;
};

export const deleteCalendarSync = async (params: DeleteCalendarSyncRequestParams) =>
  apiClient.delete<void, ApiClientResponse<void>>(routes.user.calendar.delete, { params });
